import useRemoteImageBlob from '@hooks/use-remote-image-blob';
import { useMemo } from 'react';

import type { CardImages } from '.cache/__types__';

export function useCardImageBlobs(cardImages?: CardImages | null) {
  // We should download the original images as blobs, so they can be manipulated in a canvas
  const profileBlob = useRemoteImageBlob(cardImages?.profile_picture?.original_url);
  const logoBlob = useRemoteImageBlob(cardImages?.company_logo?.original_url);
  const coverBlob = useRemoteImageBlob(cardImages?.cover_photo?.original_url);
  const imgBlobs = useMemo(() => {
    return {
      profile: profileBlob,
      logo: logoBlob,
      cover: coverBlob,
    };
  }, [profileBlob, logoBlob, coverBlob]);
  return imgBlobs;
}
